import { ZCDTypography } from '@zencity/common-ui';
import i18next from 'i18next';
import React from 'react';
import { OverallSatisfactionScoreQuestion } from 'screens/WidgetGenerator/utils/misc';
import styles from './ServicesBarChartWidget.module.scss';
import { Body } from './components/Body';
import { BodyRow } from './components/BodyRow/BodyRow';
import { Cell } from './components/Cell';
import { Header } from './components/Header/Header';
import { Legend } from './components/Legend/Legend';
import { Row } from './components/Row';
import { Table } from './components/Table/Table';
import { determineHighlightedRows, determineRowHeight } from './helpers';

interface Props {
  widgetData: OverallSatisfactionScoreQuestion[];
  displayNoDataExplanation?: boolean;
}

const TITLES = [
  i18next.t('widgetGenerator.widgets.servicesBarChart.columns.communityCharacteristic'),
  i18next.t('widgetGenerator.widgets.servicesBarChart.columns.satisfactionScore'),
  i18next.t('widgetGenerator.widgets.servicesBarChart.columns.change'),
];

export const ServicesBarChartWidget = (props: Props) => {
  const { widgetData, displayNoDataExplanation } = props;
  const highlightedRowIds = determineHighlightedRows(widgetData);

  return (
    <div className={styles.root}>
      <Table>
        <Header>
          <Row>
            {TITLES.map((title, index) => (
              <Cell key={title}>
                <ZCDTypography variant="t-heading-6" noWrap align={index === TITLES.length - 1 ? 'center' : 'left'}>
                  {title}
                </ZCDTypography>
              </Cell>
            ))}
          </Row>
        </Header>
        <Body>
          {widgetData.map((service) => {
            const rowHeight = determineRowHeight(widgetData);
            const isHighlighted = highlightedRowIds.includes(service.genericQuestionId);
            return <BodyRow rowData={service} key={service.text} isHighlighted={isHighlighted} rowHeight={rowHeight} />;
          })}
        </Body>
      </Table>
      <Legend displayNoDataExplanation={displayNoDataExplanation} />
    </div>
  );
};
